export default __webpack_public_path__ + "static/media/icon-phoneSupport.8fdc0976.svg";